import {useSetUserAccountMutation} from 'store/Store'
import {
    accountFieldValidation,
    createAccountField,
    editAccountField,
} from 'constants/FormField/createAccountField'
const useSites = () => {
    const [doSetUserAccount] = useSetUserAccountMutation()
    const handleOnClickRow = (rowData) => {
        doSetUserAccount({accountId: rowData?._id})
    }

    return {
        handleOnClickRow,
        fieldsEdit: editAccountField,
        fieldsCreate: createAccountField,
        validationSchema: accountFieldValidation,
    }
}

export default useSites
